import instagram from "../../assets/instagram.svg";
import linkedin from "../../assets/linkedin.svg";
import email from "../../assets/email-icon.svg";
import digitalMarketing from "../../assets/digital-marketing.png";

export const skillIcons = [
  instagram,
  linkedin,
  email,
  digitalMarketing,
  instagram,
  linkedin,
  email,
  digitalMarketing,
  instagram
];
